<template>
  <div>
    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="shadow overflow-hidden sm:rounded">
            <table class="min-w-full divide-y divide-gray-200">
              <thead>
                <tr>
                  <th class="px-6 py-3 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                  <th class="px-6 py-3 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Antiguedad</th>
                  <th class="px-6 py-3 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Semana Pagada</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <ItemPrimaVacacional v-for="(prima, key) in primavacacional" :prima="prima" :key="key" class="bg-white odd:bg-gray-100" />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItemPrimaVacacional from './ItemPrimaVacacional'
export default {
  name: 'ListPrimaVacacional',
  props: {
    primavacacional: Array
  },
  components: {
    ItemPrimaVacacional
  }
}
</script>
